import { FileUpload } from '../components/FileUpload';
import type { FormData } from '../types';

interface Props {
  data: FormData;
  onChange: (updates: Partial<FormData>) => void;
  errors?: Record<string, string>;
}

export function W9Step({ data, onChange, errors = {} }: Props) {
  return (
    <div>
      <div className="step-header">
        <h2>W-9 Form</h2>
        <p>We need a completed W-9 form so we can report the payments we make to your company to the IRS. This is required by law for all subcontractors.</p>
      </div>

      <div className="info-callout" style={{ marginBottom: 20 }}>
        <strong>What is a W-9?</strong> A W-9 is a one-page IRS tax form that gives us your company name, address, and tax ID number. You fill it out, sign it, and upload it here.
      </div>

      <div className="alert alert-success" style={{ marginBottom: 20 }}>
        <strong>Need a blank W-9 form?</strong>{' '}
        <a
          href="https://www.irs.gov/pub/irs-pdf/fw9.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'inherit', fontWeight: 600, textDecoration: 'underline' }}
        >
          Download one here from the IRS website
        </a>
        . Fill it out, sign it, then save or take a picture of the completed form.
      </div>

      <FileUpload
        label="Upload Your Completed W-9"
        required
        accept=".pdf,.jpg,.jpeg,.png"
        file={data.w9File}
        onChange={(w9File) => onChange({ w9File })}
        error={errors.w9File}
        hint="Upload a PDF, photo, or scan of your signed W-9. It must be dated in the current year."
      />
    </div>
  );
}
